

























import Vue from 'vue';
import OnlinePaymentResourceViewModel from '@/src/services/viewModel/resource/OnlinePaymentResourceViewModel';

export default Vue.extend({
  auth: true,
  props: {
    value: { type: Object, default: undefined },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    invoiceId(): string {
      return this.$router.currentRoute.params.id;
    },
    innerValue: {
      get(): OnlinePaymentResourceViewModel {
        return this.value ?? {};
      },
      set(value: OnlinePaymentResourceViewModel) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    'innerValue.amount': {
      deep: true,
      handler() {
        this.prefillAmount();
      },
    },
  },
  mounted() {
    this.prefillAmount();
  },
  methods: {
    prefillAmount() {
      if (this.innerValue.amount) {
        this.innerValue.amount = Number.parseFloat(`${this.innerValue.amount}`);
        this.$routerUtils.updateQueryParams({ amount: this.innerValue.amount });
      } else {
        const amount = this.$router.currentRoute.query.amount as string;
        if (amount) {
          this.innerValue.amount = Number.parseFloat(amount);
        }
      }
    },
  },
});
